/* Reana Foods – Nutrition Academy goal detail view.
   Migrated from the page.nutritionacademy Custom Liquid script.
   Goal data comes from the "Health goal" blocks, related articles from the
   "Blog post" blocks, so everything is editable in the Theme Editor. */
(function () {
  if (window.ReanaNA) return;

  var currentKey = null;

  function detail() { return document.querySelector('[data-na-detail]'); }
  function goalEl(key) {
    var all = document.querySelectorAll('[data-na-goal]');
    for (var i = 0; i < all.length; i++) if (all[i].dataset.naGoal === key) return all[i];
    return null;
  }
  function firstGoal() { return document.querySelector('[data-na-goal]'); }

  function postById(id) {
    var all = document.querySelectorAll('[data-na-post]');
    for (var i = 0; i < all.length; i++) if (all[i].dataset.naPost === id) return all[i];
    return null;
  }

  function cleanClone(node) {
    var clone = node.cloneNode(true);
    [clone].concat(Array.prototype.slice.call(clone.querySelectorAll('*'))).forEach(function (el) {
      Array.prototype.slice.call(el.attributes).forEach(function (a) {
        if (a.name.indexOf('data-shopify') === 0 || a.name === 'id') el.removeAttribute(a.name);
      });
    });
    return clone;
  }

  function render(key) {
    var d = detail();
    var g = goalEl(key);
    if (!d || !g) return false;

    var title = g.dataset.title || '';
    var set = function (sel, text) {
      var el = d.querySelector(sel);
      if (el) el.textContent = text;
    };
    set('[data-na-goal-title]', title);
    set('[data-na-goal-desc]', g.dataset.desc || '');

    var journey = d.querySelector('[data-na-goal-journey]');
    if (journey) journey.textContent = (journey.dataset.template || '[goal]').split('[goal]').join(title);

    var grid = d.querySelector('[data-na-related]');
    var empty = d.querySelector('[data-na-related-empty]');
    if (grid) {
      grid.innerHTML = '';
      var ids = (g.dataset.related || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      ids.forEach(function (id) {
        var post = postById(id);
        if (post) grid.appendChild(cleanClone(post));
      });
      var hasItems = grid.children.length > 0;
      grid.hidden = !hasItems;
      if (empty) empty.hidden = hasItems;
    }
    return true;
  }

  function open(key, opts) {
    opts = opts || {};
    var d = detail();
    if (!d || !render(key)) return;
    currentKey = key;
    document.body.classList.add('na-goal-open');
    d.classList.add('active');
    d.setAttribute('aria-hidden', 'false');
    if (!opts.silent) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var back = d.querySelector('[data-na-back]');
      if (back) back.focus({ preventScroll: true });
    }
  }

  function close(opts) {
    opts = opts || {};
    var d = detail();
    var key = currentKey;
    currentKey = null;
    document.body.classList.remove('na-goal-open');
    if (d) {
      d.classList.remove('active');
      d.setAttribute('aria-hidden', 'true');
    }
    if (window.history && window.history.replaceState && /[?&]goal=/.test(window.location.search)) {
      var params = new URLSearchParams(window.location.search);
      params.delete('goal');
      var qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    }
    if (!opts.silent) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var trigger = key && goalEl(key);
      if (trigger && trigger.tagName === 'BUTTON') trigger.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var goal = e.target.closest('button[data-na-goal]');
    if (goal) {
      e.preventDefault();
      open(goal.dataset.naGoal);
      return;
    }
    if (e.target.closest('[data-na-back], [data-na-more]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && currentKey) close();
  });

  function openFromUrl() {
    var key = new URLSearchParams(window.location.search).get('goal');
    if (key && goalEl(key)) open(key, { silent: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromUrl);
  } else {
    openFromUrl();
  }

  /* ---------- Theme Editor support ---------- */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-na-detail]')) {
      var g = currentKey ? goalEl(currentKey) : firstGoal();
      if (g) open(g.dataset.naGoal, { silent: true });
    }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-na-detail]')) close({ silent: true });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var g = e.target.closest && e.target.closest('[data-na-goal]');
    if (g && currentKey) open(g.dataset.naGoal, { silent: true });
  });
  document.addEventListener('shopify:section:load', function () {
    if (currentKey) {
      if (!render(currentKey)) close({ silent: true });
      else {
        var d = detail();
        if (d) { d.classList.add('active'); d.setAttribute('aria-hidden', 'false'); }
      }
    }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target.querySelector('[data-na-detail]')) return;
    /* Re-rendered sections fire unload then load; only close if it was removed */
    window.setTimeout(function () {
      if (!detail()) close({ silent: true });
    }, 60);
  });

  window.ReanaNA = { open: open, close: close };
})();
